var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.getAriaText(_vm.params)))]),(!_vm.params.node.group)?_c('c-performance',{attrs:{"value":_vm.value,"valueFormatted":_vm.valueFormatted,"min":_vm.min,"max":_vm.max}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }